import type { RouteDataFunc } from "@solidjs/router";
import { signOut } from "supertokens-web-js/lib/build/recipe/thirdpartyemailpassword";
import { axiosClient } from "~/js/network/axiosClient";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { routerConfig } from "~/solidJs/app/MainApp/models";
import { BaseApi } from "~/solidJs/shared/api/baseApi";

import { getPrivateMessageFromError } from "~/solidJs/shared/helpers";
export class AppSumoApi extends BaseApi {
	static appsumoLocalStorageKey = "appsumo_code";
	static async postAppSumoCode(code: string) {
		try {
			await axiosClient.axiosClient.post(
				`${AppSumoApi.baseUrlV2}/appsumo/check_user_code`,
				{},
				{ params: { code } }
			);
		} catch (error) {
			EventAnalytics.sendErrorInfo("appsumo_register_error", {
				message: getPrivateMessageFromError(error)
			});
			throw error;
		}
	}
	static saveAppSumoCode(code: string) {
		localStorage.setItem(AppSumoApi.appsumoLocalStorageKey, code);
	}
	static async registerAppSumoCode() {
		const code = localStorage.getItem(AppSumoApi.appsumoLocalStorageKey);
		if (!code) {
			return false;
		}
		try {
			await AppSumoApi.postAppSumoCode(code);
		} catch {
			return false;
		}
		localStorage.removeItem(AppSumoApi.appsumoLocalStorageKey);
		return true;
	}
}
export const appSumoData: RouteDataFunc = async (props) => {
	const code = props.location.query.code;
	if (!code) {
		props.navigate(routerConfig.signIn.absolute, { replace: true });
		EventAnalytics.sendErrorInfo("appsumo_no_code_error", {
			message: "No code provided"
		});
		return;
	}
	AppSumoApi.saveAppSumoCode(code);
	await signOut();
	props.navigate(routerConfig.signIn.absolute, { replace: true });
};
